import { Guideline } from '@/types/community/guideline';

export const guidelines: Guideline[] = [
  {
    id: 'GL001',
    records: [
      {
        content: '1. Não mergulhar em áreas rasas\n2. Crianças menores de 12 anos devem estar acompanhadas por adultos\n3. Não são permitidos recipientes de vidro\n4. Traje de banho adequado obrigatório\n5. Não correr no deck da piscina',
        category: 'amenity_usage',
        subPolicy: 'swimming_pool',
        attachments: [
          {
            id: 'ATT001',
            name: 'regras_piscina.pdf',
            type: 'application/pdf',
            size: 1024,
            path: '/documents/guidelines/GL001/pool_rules.pdf',
            url: 'https://example.com/docs/pool_rules.pdf',
            uploadedAt: new Date('2024-01-01')
          }
        ]
      },
      {
        content: '1. Máximo 2 horas por sessão\n2. Traje de academia adequado obrigatório\n3. Limpar equipamentos após o uso\n4. Não são permitidos alimentos ou bebidas\n5. Crianças menores de 16 anos devem ser supervisionadas',
        category: 'amenity_usage',
        subPolicy: 'gym',
        attachments: []
      },
      {
        content: '1. Uma vaga de estacionamento por unidade\n2. Não estacionar nas faixas de incêndio\n3. Estacionamento para visitantes disponível em áreas designadas\n4. Não estacionar veículos comerciais durante a noite\n5. Reportar veículos abandonados imediatamente',
        category: 'parking_vehicles',
        subPolicy: 'resident_parking',
        attachments: []
      },
      {
        content: '1. Manter níveis de ruído razoáveis\n2. Não fazer festas após 22h\n3. Descarte de lixo adequadamente\n4. Respeitar áreas comuns\n5. Reportar problemas de manutenção prontamente',
        category: 'general_conduct',
        subPolicy: 'noise_levels',
        attachments: []
      },
      {
        content: '1. Todos os visitantes devem ser registrados\n2. Câmeras de segurança são monitoradas\n3. Reportar atividades suspeitas\n4. Manter portas e janelas trancadas\n5. Contatos de emergência devem ser atualizados',
        category: 'safety_security',
        subPolicy: 'emergency_procedures',
        attachments: []
      },
      {
        content: '1. Enviar solicitações através do portal\n2. Solicitações de emergência são priorizadas\n3. Fornecer acesso quando solicitado\n4. Acompanhar trabalhos concluídos\n5. Avaliar qualidade do serviço',
        category: 'maintenance_requests',
        subPolicy: 'request_procedures',
        attachments: []
      },
      {
        content: '1. Comunicados oficiais são enviados por email e portal\n2. Notificações urgentes são enviadas por SMS\n3. Período de aviso mínimo de 24 horas para mudanças\n4. Eventos são anunciados com 7 dias de antecedência\n5. Respostas devem ser confirmadas em 48 horas',
        category: 'announcements_notifications',
        subPolicy: 'communication_channels',
        attachments: []
      },
      {
        content: '1. Despesas comuns são divididas igualmente entre todas as unidades\n2. Taxa de manutenção mensal: R$ 150,00 por unidade\n3. Fundo de reserva para emergências: 10% da receita mensal\n4. Seguro do condomínio cobre danos estruturais\n5. Relatórios financeiros são publicados trimestralmente',
        category: 'common_expenses',
        subPolicy: 'utility_sharing',
        attachments: []
      }
    ],
    status: 'active',
    author: {
      id: 'emp-1',
      name: 'João Silva',
      type: 'employee'
    },
    effectiveDate: new Date('2024-01-01'),
    version: '1.0',
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'guideline-2',
    records: [
      {
        content: 'Regras de estacionamento para residentes e visitantes',
        category: 'parking_vehicles',
        subPolicy: 'resident_parking',
      }
    ],
    status: 'active',
    author: {
      id: 'emp-2',
      name: 'Maria Santos',
      type: 'employee'
    },
    effectiveDate: new Date('2024-01-01'),
    version: '1.0',
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'guideline-3',
    records: [
      {
        content: 'Normas de comportamento para residentes',
        category: 'general_conduct',
        subPolicy: 'noise_levels',
      }
    ],
    status: 'active',
    author: {
      id: 'emp-3',
      name: 'Carlos Oliveira',
      type: 'employee'
    },
    effectiveDate: new Date('2024-01-01'),
    version: '1.0',
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'guideline-4',
    records: [
      {
        content: 'Protocolos de segurança e emergência',
        category: 'safety_security',
        subPolicy: 'emergency_procedures',
      }
    ],
    status: 'active',
    author: {
      id: 'emp-1',
      name: 'João Silva',
      type: 'employee'
    },
    effectiveDate: new Date('2024-01-01'),
    version: '1.0',
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  }
]; 